import React from 'react';
const partners = [{
  name: 'Fatherhood Foundation of Virginia',
  logo: 'https://cdn.magicpatterns.com/uploads/m6E57sGjmmrpnH3eBi2HRt/FF_Logo2022_Red.png'
}, {
  name: 'Harrisonburg City Public Schools',
  logo: 'https://cdn.magicpatterns.com/uploads/3hEEMgs5SwXe9jWkNSzQSt/HCPS_OfficialFullLogoColorLight.jpg'
}, {
  name: 'Harrisonburg Downtown Renaissance',
  logo: 'https://cdn.magicpatterns.com/uploads/7cYeCTEGcjiLk91oUC9pEs/HDR_Logo.png.webp'
}, {
  name: 'Rockingham County Public Schools',
  logo: 'https://cdn.magicpatterns.com/uploads/wndka9hz7cePxUiPQeDgVE/RCPS-Logo.png'
}];
export function PartnersSection() {
  return <section className="py-16 bg-white" data-id="element-139">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-140">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] mb-10" data-id="element-141">
          Thank You to Our Partners
        </h2>

        {/* Carousel container */}
        <div className="relative overflow-hidden" data-id="element-142">
          <div className="flex animate-scroll" data-id="element-143">
            {/* First set of logos */}
            {partners.map((partner, index) => <div key={`first-${index}`} className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center" data-id="element-144">
                <img src={partner.logo} alt={partner.name} className="h-16 md:h-20 w-auto object-contain" data-id="element-145" />
              </div>)}
            {/* Duplicate set for seamless loop */}
            {partners.map((partner, index) => <div key={`second-${index}`} className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center" data-id="element-146">
                <img src={partner.logo} alt={partner.name} className="h-16 md:h-20 w-auto object-contain" data-id="element-147" />
              </div>)}
          </div>
        </div>
      </div>

      <style data-id="element-148">{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 25s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}